// 翻譯管理中心
import zh from './zh';
import en from './en';
import fil from './fil';
import vi from './vi';
import id from './id';
import th from './th';

export const languages = [
  { code: 'zh', name: '中文', flag: '🇹🇼' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'fil', name: 'Filipino', flag: '🇵🇭' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'id', name: 'Bahasa', flag: '🇮🇩' },
  { code: 'th', name: 'ไทย', flag: '🇹🇭' }
];
const translations = { zh, en, fil, vi, id, th };
export const getTranslation = (lang = 'zh') => translations[lang] || translations.zh;
export const getLanguageName = (code) => languages.find((lang) => lang.code === code)?.name || '中文';
export const isLanguageSupported = (code) => languages.some((lang) => lang.code === code);
export default translations;
